import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-client-profile-toolbar',
    templateUrl: './client-profile-toolbar.component.html',
    styleUrls: ['./client-profile-toolbar.component.scss'],
    standalone: false
})
export class ClientProfileToolbarComponent {
  // Declare @Input Variables
  @Input() refreshButton: any;
  @Input() files: any;
  @Input() permissions_createfolder: boolean = false;

  // Declare @Output Variables
  @Output() handleRefreshEvent: EventEmitter<any> = new EventEmitter();
  @Output() openFileSearchEvent: EventEmitter<any> = new EventEmitter();
  @Output() createFolderEvent: EventEmitter<any> = new EventEmitter();

  constructor() {}

  handleRefresh() {
    this.handleRefreshEvent.emit();
  }

  openFileSearch() {
    this.openFileSearchEvent.emit();
  }

  createFolder() {
    this.createFolderEvent.emit();
  }
}
